<template>
   <page-loader v-if="loadStatus == 'loading'" />
  <div v-else class="contain-section px-0">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-box">
          <div class="banner-box h-400">
            <img :src="references &&  references.main_image ? references.main_image[0].url : '' " alt="Logo">
          </div>
          <div class="inner-content">
            <h3 class="f">{{ references ? references.heading : '' }}</h3>
            <div v-html="references ? references.text : ''"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import "../../styles/pages/ancentry/recent-ancetry.scss";
import "../../styles/pages/ancentry/neanderthal-main.scss";
import { getArchaicReferences } from "@/services/archaic"
import { ref, onMounted,watch, nextTick } from "vue"; 
export default {
  name: "ArchaicReferences",
  setup () {
    const loadStatus = ref("loading");
      const references = ref({});
      watch(references, async () => {
        await nextTick(); // Wait until the DOM updates with v-html content
        document.querySelectorAll(".inner-content p").forEach(p => {
          if (p.textContent.includes("https:")) {
            p.classList.add("word-break");
          }
        });
      });
      onMounted(async () => {
        references.value = await getArchaicReferences();
        loadStatus.value = "loaded";
      });
      console.log(references);
    return { loadStatus, references }
  }
};
</script>
<style lang="scss">
.word-break{
  word-break: break-all;
}
</style>